import {
  GETTING_PROPERTY_OCCUPANCY_INFO,
  UPDATE_PROPERTY_INFO,
  UPDATE_VEHICLE_INFO,
} from '../actions/actionTypes';

import {
  ALL_PROPERTY_TYPES,
  ALL_OCCUPANCY_TYPES,
  PRIMARY_RESIDENCE,
  SINGLE_FAMILY,
} from '../constants/Dashboard/Financing/mortgage';

const DEFAULT_STATE = {
  ALL_PROPERTY_TYPES,
  ALL_OCCUPANCY_TYPES,
  occupancyType: PRIMARY_RESIDENCE,
  propertyType: SINGLE_FAMILY,
};

export const propertyReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case GETTING_PROPERTY_OCCUPANCY_INFO:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_PROPERTY_INFO:
      return {
        ...state,
        ...action.payload,
      };

    case UPDATE_VEHICLE_INFO:
      // Setting the financingType to Auto
      return {
        ...state,
        financingType: action.payload.financingType,
      };

    default:
      return {
        ...state,
      };
  }
};
